import { Customer } from "@/models/response/customer";
import AddCustomer from "@/pages/dashboard/customer/add";
import UseGetCustomerById from "@/pages/dashboard/customer/hooks/useGetCustomerById";
import { Drawer } from "@mantine/core";
import { useEffect, useState } from "react";

type Props = {
  opened: boolean;
  close: () => void;
  refetch: () => void;
  setSelectedCustomer: (customer: Customer) => void;
  closeCustomers: () => void;
};

function AddNewCustomer({
  opened,
  close,
  refetch,
  setSelectedCustomer,
  closeCustomers,
}: Props) {
  const [customerId, setCustomerId] = useState<number>(0);
  const { data: customer, isSuccess } = UseGetCustomerById({
    id: customerId,
  });

  useEffect(() => {
    if (customer) {
      setSelectedCustomer(customer);
    }
  }, [customer, setSelectedCustomer]);

  useEffect(() => {
    if (isSuccess) {
      close();
      refetch();
      closeCustomers();
    }
  }, [isSuccess, close, refetch]);

  return (
    <Drawer
      opened={opened}
      onClose={close}
      position="bottom"
      radius="md"
      size="xl"
      withCloseButton={false}
      zIndex={103}
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <AddCustomer
        close={(customerId) => {
          if (customerId === 0) close()
          else
            setCustomerId(customerId);
        }}
      />
    </Drawer>
  );
}

export default AddNewCustomer;
